import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { getIsUserSignedIn } from "@gamedev-web/gamedev-sdk-core";

import { siteLocationPrefix } from "./urls";

export const signInUrl = `${siteLocationPrefix}/auth/login`;
export const signOutUrl = `${siteLocationPrefix}/auth/logout`;
export const switchAccountUrl = `${siteLocationPrefix}?prompt=login`;

/**
 * Hook to handle authentication-aware navigation
 * @param targetPath - The path to navigate to after successful authentication
 * @returns Object containing navigation function and current URL.
 */
export const useAuthenticatedNavigation = (targetPath: string) => {
  const [signInUrlWithCallback, setSignInUrlWithCallback] = useState("");
  const isSignedIn = useSelector(getIsUserSignedIn);

  useEffect(() => {
    if (isSignedIn) {
      // If signed in, return the direct target path
      setSignInUrlWithCallback(`${window.location.origin}${targetPath}`);
    } else {
      // If not signed in, return sign-in URL with callback
      setSignInUrlWithCallback(`${signInUrl}?callbackUrl=${window.location.origin}${targetPath}`);
    }
  }, [targetPath, isSignedIn]);

  return signInUrlWithCallback;
};
